/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([
    './searchModel',
    './lowBandwidthSearchModel',
    './entryPointModel'
], function(
    SearchModel,
    LowBandwidthSearchModel,
    EntryPointModel
) {
    'use strict';
    function createCorrectModel(data, additionalData) {
        if (typeof data.tp !== 'undefined') {
            return new LowBandwidthSearchModel(data);
        } else if (data.type === 'main' || data.type === 'minor') {
            return new EntryPointModel(data, additionalData);
        } else {
            return new SearchModel(data);
        }
    }

    return function(json, additionalData) {
        var resultsArray = json.results || json.r;

        if (resultsArray instanceof Array) {
            return resultsArray.map(function(result) {
                return createCorrectModel(result, additionalData);
            });
        } else {
            return createCorrectModel(json, additionalData);
        }
    };
});



// WEBPACK FOOTER //
// ./model/search/modelFactory.js